import Cookies from 'js-cookie';

export const webToLeadData = (values) => {
  return {
    [salesforceFieldMapping.oid]:
      process.env.NEXT_PUBLIC_SALESFORCE_WEB_TO_LEAD_OID,
    [salesforceFieldMapping.lead_source]: 'heycater.com Web2Lead form',
    [salesforceFieldMapping.entrance_url]: Cookies.get('entrance_url'),
    [salesforceFieldMapping.referrer_url]: Cookies.get('referrer_url'),
    [salesforceFieldMapping.conversion_url]: window.location.href,
    ...Object.keys(values).reduce((accumulator, key) => {
      return { ...accumulator, [salesforceFieldMapping[key]]: values[key] };
    }, {}),
  };
};

const salesforceFieldMapping = {
  entrance_url: '00N1i000001A0eY',
  referrer_url: '00N1i000001A0eT',
  lead_source: 'lead_source',
  conversion_url: '00N1i000002WWRT',
  last_name: 'last_name',
  name: 'last_name',
  email: 'email',
  phone: 'phone',
  comment: '00N58000007Q0vz',
  record_type: 'recordType',
  oid: 'oid',
  city: '00N5800000CZO0T',
  caterer_type: '00N1i000002IQkc',
  first_name: 'first_name',
  zip_code: 'zip',
  address: 'street',
  caterer_name: 'company',
};
